import React from "react";
import { WithStyles, withStyles, Grid } from "material-ui";
import { FormControlLabel } from "material-ui/Form";
import { InjectedFormProps, reduxForm } from "redux-form";

import ExtendedField from "../../../components/form/ExtendedField";
import renderTextField from "../../../components/form/RenderTextField";
import renderSelectField from "../../../components/form/RenderSelectField";
import renderCheckBox from "../../../components/form/RenderCheckBoxWithLabel";

import { LoanEditRequestDto } from "../../../util/DTOs/LoanDtos";
import validate from "./validate/LoanEditFormValidator";

const styles = {} as React.CSSProperties;

export interface LoanEditFormData extends LoanEditRequestDto {}

interface LoanEditFormProps {
    editTypeId: number;
    loansList: { label: string; value: string }[];
    editTypeIdList: { label: string; value: number; price: string }[];
}

type LoanEditPagePropsWithStyles = LoanEditFormProps &
    InjectedFormProps<LoanEditFormData, LoanEditFormProps> &
    WithStyles;

const LoanEditForm: React.SFC<LoanEditPagePropsWithStyles> = (props) => {
    const editTypeId = Number(props.editTypeId);

    return (
        <Grid container>
            <Grid item xs={12}>
                <h4 className="hypodgrey" style={{ marginBottom: 0 }}>
                    Valitse laina, jolle haluat tehdä muutoksen:{" "}
                </h4>
                <ExtendedField
                    component={renderSelectField}
                    name="loanId"
                    type="select"
                    placeholder=""
                    label="Laina"
                    required={true}
                    options={props.loansList}
                />
            </Grid>
            <Grid item xs={12}>
                <h4 className="hypodgrey" style={{ marginBottom: 0 }}>
                    Valitse muutoksen tyyppi:{" "}
                </h4>
                <ExtendedField
                    component={renderSelectField}
                    name="editTypeId"
                    type="select"
                    placeholder=""
                    label="Muutostyyppi"
                    required={true}
                    options={props.editTypeIdList}
                />
            </Grid>
            <Grid item xs={12}>
                {editTypeId > 0 && (
                    <h4
                        className="hypodgrey"
                        style={{ marginTop: 0, textAlign: "right" }}
                    >
                        Muutoksen hinta:{" "}
                        <span className="highlight">
                            {props.editTypeIdList[editTypeId - 1].price}
                        </span>
                    </h4>
                )}
            </Grid>
            {editTypeId === 1 && (
                <Grid item xs={12}>
                    <ExtendedField
                        component={renderTextField}
                        name="maturityDate"
                        type="number"
                        placeholder=""
                        adornment=""
                        label={"Eräpäivä"}
                        required={true}
                    />
                </Grid>
            )}
            {editTypeId === 2 && (
                <Grid item xs={12}>
                    <ExtendedField
                        component={renderTextField}
                        name="monthlyAmount"
                        type="number"
                        placeholder=""
                        className="input-align-center"
                        adornment="€"
                        label={"Kuukausierä"}
                        required={true}
                    />
                </Grid>
            )}
            {editTypeId === 3 && (
                <Grid item xs={12}>
                    <ExtendedField
                        component={renderTextField}
                        name="loanEndDate"
                        type="date"
                        placeholder=""
                        adornment=""
                        label={"Toivottu viimeinen maksuajankohta"}
                        required={true}
                    />
                </Grid>
            )}
            {editTypeId === 4 && (
                <Grid item xs={9} sm={6}>
                    <ExtendedField
                        component={renderTextField}
                        name="startDate"
                        type="date"
                        placeholder=""
                        adornment=""
                        label={"Alkaen"}
                        required={true}
                    />
                </Grid>
            )}
            {editTypeId === 4 && (
                <Grid item xs={9} sm={6}>
                    <ExtendedField
                        component={renderTextField}
                        name="endDate"
                        type="date"
                        placeholder=""
                        adornment=""
                        label={"Päättyen"}
                        required={true}
                    />
                </Grid>
            )}
            <Grid item xs={12}>
                <h4 className="hypodgrey" style={{ marginBottom: 0 }}>
                    Toivottu yhteydenottotapa:{" "}
                </h4>
                <ExtendedField
                    component={renderCheckBox}
                    color="primary"
                    name="contactByEmail"
                    type="checkbox"
                    normalize={(v) => !!v}
                    label={"Sähköposti"}
                    required={true}
                />
                <ExtendedField
                    component={renderCheckBox}
                    color="primary"
                    name="contactByPhone"
                    type="checkbox"
                    normalize={(v) => !!v}
                    label={"Puhelin"}
                    required={true}
                />
            </Grid>
            <Grid item xs={12}>
                <ExtendedField
                    component={renderTextField}
                    name="reasonAndDetails"
                    type="text"
                    placeholder=""
                    adornment=""
                    multiline={true}
                    label={"Muutoksen syy / lisätiedot"}
                    required={true}
                />
            </Grid>
        </Grid>
    );
};

export default reduxForm<LoanEditFormData, LoanEditFormProps>({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(withStyles(styles)(LoanEditForm));



// WEBPACK FOOTER //
// ./src/views/loan/components/loanEditForm.tsx